import type { RouteRecordRaw } from 'vue-router'

const meetRoutes: RouteRecordRaw = {
  path: '/meet',
  name: 'meet',
  meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'common.titles.meet' },
  component: () => import('@/pages/meet/MeetPage.vue'),
}

export default meetRoutes
